import $api, {API_URL} from "./instance";
import errorMessage from "../const/Tost";

export const patientService = {
    async getPatientInfo(id){
        try{
            return await $api.get(`${API_URL}/patient/${id}?withAssociates=true`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async editPatientInfo(id, data){
        try{
            return await $api.put(`${API_URL}/patient/` + id, data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async FindPatientByParam(data){
        try{
            return await $api.get(`${API_URL}/patient?` + data)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }, async getInfoByPatient(id, data){
        try{
            return await $api.get(`${API_URL}/direction/all?withAssociates=true&patientId=${id}&${data}`)
        } catch(error){
            errorMessage(error, error?.response?.data?.message);
        }
    }
};